module.exports = __webpack_public_path__ + "img/casa-cody-logo.8fd334e2.png";